import { render, staticRenderFns } from "./ArmadaDetail.vue?vue&type=template&id=a5ceb332&scoped=true&"
import script from "./ArmadaDetail.vue?vue&type=script&lang=js&"
export * from "./ArmadaDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArmadaDetail.vue?vue&type=style&index=0&id=a5ceb332&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ceb332",
  null
  
)

export default component.exports